import {Tabs} from 'antd';
import {useEffect, useState} from 'react';
import {getAllBuyers} from "../../api/Api";
import {NewBuyerInput} from "./NewBuyerInput";
import {BuyerTable} from './BuyerTable';
import {BalancesDue} from "./BalancesDue";

export const BuyerTab = ({refresh, onRefresh, onApiFail, props}) => {
    const [buyers, setBuyers] = useState([]);
    const [buyerRefresh, setBuyerRefresh] = useState(0);
    useEffect(() => {
        getAllBuyers().then(data => {
            const b = data.map(val => {
                return {
                    key: val.id,
                    ...val,
                }
            })
            setBuyers(b);
        }).catch(e => {
            if (e.status === 401) {
                if (onApiFail) {
                    onApiFail();
                }
            }
        });
    }, [onApiFail, buyerRefresh]);

    const onBuyerRefresh = () => {
        setBuyerRefresh(buyerRefresh+1)
    }

    const items = [
        {
            key: 'AllBuyers',
            label: 'All Buyers',
            children: <BuyerTable buyers={buyers} onApiFail={onApiFail}/>
        },
        {
            key: 'BalancesDue',
            label: 'Balances Due',
            children: <BalancesDue buyers={buyers} refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail}/>
        },
        {
            key: 'NewBuyer',
            label: 'New Buyer',
            children: <NewBuyerInput onRefresh={onBuyerRefresh} />
        }
    ];

    const onTabChange = () => {
        console.log('on tab change');
    }

    const onClick = () => {
        console.log('on click');
    }

    return <Tabs defaultActiveKey={'AllBuyers'} tabPosition={'left'} items={items} onChange={onTabChange} onTabClick={onClick}/>
}